module.exports = __webpack_public_path__ + "img/bets-providers.eb5290ee.png";